<template>
  <div>
  <div id="movelist-container" :key="moveListTrigger">
    <div v-for="item in resultsData" v-bind:key="item.san">
      <div class="movelist-row" v-bind:class="hoverClassObject" 
              :class="{
                'reptree-selected-text-dark' : item.highlightPlayerMove && isDark,
                'reptree-selected-text-light' : item.highlightPlayerMove && !isDark,
                'movelist-font-bold' : item.textType == 'needed',
                'movelist-font-italic' : item.textType == 'done',
                'movelist-font-normal' : item.textType == 'ignore' || item.textType == 'player'}">

        <div v-if="showCheckBoxes" class="movelist-checkbox">
            <input  type="checkbox" value="" 
                  @change="onCheckboxChange($event,item.index)"
                  v-model="item.selected">
        </div>

        <!-- SAN -->
        <div class="movelist-text movelist-text-left" @click="onClickMove(item.index,true)">
                {{ (item.san == "total") ? t("total") : item.san }}
        </div>
        
        <!-- percentage -->
        <div v-if="showPercentage" class="movelist-text movelist-text-right" 
                @click="onClickMove(item.index,false)">
                {{ item.percentDisplay }}
        </div>

        <!-- weighted score -->
        <div class="movelist-text movelist-text-right" @click="onClickMove(item.index,false)">
                {{ item.weightedScores[(Number(props.moveNumber) - 9) / 3] }}
        </div>

        <!-- game count total -->
        <div class="movelist-text movelist-text-right" @click="onClickMove(item.index,false)">
                {{ item.countDisplay }}
        </div>

      </div>
      
    </div>
  </div>
  </div>
</template>


<script setup>

  import { computed } from "@vue/reactivity"
  import { ref , onBeforeUpdate } from 'vue'
  import { watch } from "vue";
  import { t } from "@/composables/translateText.js";

  import { useConnectionStore } from '@/stores/connectionStore';

  const props = defineProps({
    resultsData : Array,
    moveNumber : {
      type : Number,
      default : 15
    },
    moveListTrigger : {
      type : Number,
      default : 0
    },
    eighty : {
      type : Number,
      default : -100
    },
    showCheckBoxes : {
      type : Boolean,
      default : true
    },
    showPercentage : {
      type : Boolean,
      default : true
    }
  })

  const emit = defineEmits(['checkbox-click','move-click'])

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light") 

  const hoverClassObject = (isDark.value) ? "dark-hover-mode" : "light-hover-mode"

  const moveListTrigger = computed({ get() { return props.moveListTrigger } })

  const showCheckboxes = computed({ get() { return props.showCheckboxes }})
  const showPercentage = computed({ get() { return props.showPercentage }})

  watch(moveListTrigger, (newVal,oldVal) => {
  })

  function onClickMove(index,isSan) {
    if (props.showCheckBoxes == false || !isSan) {
      emit("move-click",index)
      return
    }

    props.resultsData[index].selected = !props.resultsData[index].selected 
    emit("checkbox-click",{index : index, flag : props.resultsData[index].selected})
  }

  function onCheckboxChange(event,index) {
    //console.log("***** on checkbox change", index)
    //console.log(" click item ",props.resultsData[index])
    //console.log(" click flag ",props.resultsData[index].selected)

    if (props.showCheckBoxes == false)
      return
 
    emit("checkbox-click",{index : index, flag : props.resultsData[index].selected})
  }

  onBeforeUpdate(() => {

  })

</script>

<style scoped>

.movelist-row {
  line-height: 1.5em;
  /*border-bottom: #d3dfe1 solid 1px;*/
  /*border-bottom: #286a6c solid 1px;*/
}

/* https://stackoverflow.com/questions/46551925/vuejs-v-bindstyle-hover */

.light-hover-mode {
  border-bottom: #d3dfe1 solid 1px;
}
.light-hover-mode:hover {
  background: #d3dfe1;
}

.dark-hover-mode {
  border-bottom: #286a6c solid 1px;
}

.dark-hover-mode:hover {
  background: #286a6c ;
}

.movelist-text {
  display: inline-block;
  width : 23%;
  bottom : 3px;
  position : relative;
  font-size: small;
}

.movelist-text-right {
  text-align: right;
}

.movelist-text-left {
  text-align: left;
}

.movelist-eighty-line {
  height : 5px;
  background : rgb(13,110,253)
}
.movelist-font-bold {
  font-weight: bold;
}

.movelist-font-normal {
  font-style: normal;
}

.movelist-font-italic {
  font-style: italic;
}
.movelist-checkbox {
    border-radius: 0.25em;
    display: inline-block;
  width : 18px;
  bottom : 3px;
  position : relative;
}

.movelist-checkbox:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.movelist-checkmark-dark {
  color : white;
}

.movelist-checkmark-light {
  color : dark;
}

.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

</style>